"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withStorefrontExperience = exports.withCaviarExperience = exports.withExperience = void 0;
/* tslint:disable prefer-array-literal */
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ExperienceRouterContext_1 = __importStar(require("./ExperienceRouterContext"));
var NullComponent = function () { return null; };
function withExperience(Component, overrideExperience) {
    return function (strings) {
        var interpolations = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            interpolations[_i - 1] = arguments[_i];
        }
        if (!Component) {
            return NullComponent;
        }
        return function (props) {
            var ExperienceComponent = Component;
            var experience = React.useContext(ExperienceRouterContext_1.default).experience;
            var experienceProps = __assign(__assign({}, props), { experience: experience });
            if (overrideExperience === experience) {
                ExperienceComponent = styled_components_1.default(Component).apply(void 0, __spread([strings], interpolations));
            }
            var ThemedExperienceComponent = design_language_1.withTheming(ExperienceComponent);
            return React.createElement(ThemedExperienceComponent, __assign({}, experienceProps));
        };
    };
}
exports.withExperience = withExperience;
function withCaviarExperience(Component) {
    return withExperience(Component, ExperienceRouterContext_1.Experience.Caviar);
}
exports.withCaviarExperience = withCaviarExperience;
function withStorefrontExperience(Component) {
    return withExperience(Component, ExperienceRouterContext_1.Experience.Storefront);
}
exports.withStorefrontExperience = withStorefrontExperience;
